import React, { useEffect, useRef } from 'react';
import { X, AlertTriangle, Eye, ShoppingBag } from 'lucide-react';
import gsap from 'gsap';
import './OutOfStockPopup.css';

const OutOfStockPopup = ({ isOpen, onClose, variantName, productName, onOpenQuickView, hasQuickView }) => {
  const overlayRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    if (isOpen && cardRef.current) {
      gsap.fromTo(overlayRef.current,
        { opacity: 0 },
        { opacity: 1, duration: 0.3, ease: 'power2.out' }
      );
      gsap.fromTo(cardRef.current,
        { scale: 0.8, opacity: 0, y: 30 },
        { scale: 1, opacity: 1, y: 0, duration: 0.45, ease: 'back.out(1.7)' }
      );
    }
  }, [isOpen]);

  const handleClose = () => {
    gsap.to(cardRef.current, {
      scale: 0.85, opacity: 0, y: 20, duration: 0.25, ease: 'power2.in',
      onComplete: onClose
    });
    gsap.to(overlayRef.current, { opacity: 0, duration: 0.25 });
  };

  if (!isOpen) return null;

  return (
    <div className="oos-overlay" ref={overlayRef} onClick={handleClose}>
      <div className="oos-card" ref={cardRef} onClick={e => e.stopPropagation()}>

        {/* Close Button */}
        <button className="oos-close-btn" onClick={handleClose}>
          <X size={18} />
        </button>

        {/* Icon */}
        <div className="oos-icon-wrap">
          <div className="oos-icon-ring" />
          <div className="oos-icon-ring oos-ring-2" />
          <AlertTriangle size={32} className="oos-alert-icon" />
        </div>

        {/* Heading */}
        <p className="oos-tag">VARIANT UNAVAILABLE</p>
        <h2 className="oos-title">Currently Out of Stock</h2>

        {/* Info */}
        <div className="oos-info-box">
          {variantName && (
            <div className="oos-info-row">
              <span className="oos-info-label">Selected Volume</span>
              <span className="oos-info-val">{variantName}</span>
            </div>
          )}
          {productName && (
            <div className="oos-info-row">
              <span className="oos-info-label">Product</span>
              <span className="oos-info-val">{productName}</span>
            </div>
          )}
          <div className="oos-info-row oos-status-row">
            <span className="oos-info-label">Status</span>
            <span className="oos-status-badge">
              <span className="oos-status-dot" />
              Out of Stock
            </span>
          </div>
        </div>

        {/* Message */}
        <p className="oos-msg">
          This volume is temporarily unavailable. Other sizes may still be in stock — explore all available options below.
        </p>

        {/* Buttons */}
        <div className="oos-actions">
          {hasQuickView && (
            <button
              className="oos-btn-primary"
              onClick={() => { handleClose(); setTimeout(onOpenQuickView, 300); }}
            >
              <Eye size={16} />
              View Other Volumes
            </button>
          )}
          <button className="oos-btn-secondary" onClick={handleClose}>
            <ShoppingBag size={15} />
            Continue Browsing
          </button>
        </div>

      </div>
    </div>
  );
};

export default OutOfStockPopup;
